import React from 'react';
import PropTypes from 'prop-types';
import IconHexagon from '@learningblocks/exp-constants/lib/Icons/hexagon-solid';
import {NOTEBOOK_SECTIONS} from '@learningblocks/exp-constants/lib/Utilities';
import './style.scss';

export class SectionMenu extends React.Component {
  componentWillMount(){}
  wrapperClass() {
    const classList = [
      this.props.current ? 'sections-list__itemActive' : 'sections-list__item',
    ];
    return classList.join(' ');
  }
  menuArrow() {
    if (this.props.current && this.props.title !== NOTEBOOK_SECTIONS.DESIGN) {
      return <div className='section-arrow'></div>;
    } else {
      return null;
    }
  }
  goToSection = () => {
    if (this.props.current === false) {
      this.props.goToSection(this.props.value);
    }
    if (this.props.current && this.props.title === NOTEBOOK_SECTIONS.DESIGN) {
      this.props.goToFirstSection();
    }
  };
  render() {
    return (
      <li className={this.wrapperClass()} onClick={this.goToSection}>
        {this.menuArrow()}
        <div className='index'>
          <span className='index-icon'>
            <IconHexagon style={{fill: "#003E6B"}} />
          </span>
          <span className='index-number'>{this.props.number}</span>
        </div>
        <div className='title'>{this.props.title}</div>
      </li>
    );
  }
}
SectionMenu.propTypes = {
  title: PropTypes.string.isRequired,
  current: PropTypes.bool.isRequired,
  number: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  goToSection: PropTypes.func.isRequired,
  goToFirstSection: PropTypes.func.isRequired,
};

SectionMenu.defaultProps = {
  goToSection: () => {},
  goToFirstSection: () => {},
};
